import {
  useAppDispatch,
  useAppSelector,
} from "@/app/lib/features/redux/redux.hook";
import { useCallback } from "react";
import { getFooter } from "./footer.thunk";
import { resetFooter } from "./footer.slice";
import { isError, isIdle, isLoading, isSuccess } from "@/app/utils/asyncStatus";

const useFooter = () => {
  const dispatch = useAppDispatch();
  const { data: footer, error: footerError, status: footerStatus } = useAppSelector(
    (store) => store.footer,
  );

  const fetchFooter = useCallback(() => {
    dispatch(getFooter());
  }, [dispatch]);

  const clearFooter = useCallback(() => {
    dispatch(resetFooter());
  }, [dispatch]);

  return {
    footer,
    footerError,
    footerStatus,
    isIdle: isIdle(footerStatus),
    isLoading: isLoading(footerStatus),
    isSuccess: isSuccess(footerStatus),
    isError: isError(footerStatus),
    fetchFooter,
    clearFooter,
  };
};

export default useFooter;